import { useConnectionStatus } from '@shared/hooks/useConnectionStatus'

export function ConnectionStatus() {
  const online = useConnectionStatus()
  return (
    <div role={online ? undefined : 'status'} aria-live="polite">
      {!online && (
        <p className="mb-4 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950 dark:bg-amber-950 dark:text-amber-100">
          Sem conexão. Os dados exibidos podem estar desatualizados. As alterações não serão
          enviadas automaticamente quando a conexão voltar. Confira o resultado antes de tentar
          novamente.
        </p>
      )}
    </div>
  )
}
